// High-quality ingredient photography resolver with transparent PNGs & localized mapping

const DO_SPACES_INGREDIENT_BASE = 'https://tdwspaces.blr1.cdn.digitaloceanspaces.com/ingredient/';
const LOCAL_INGREDIENT_BASE = '/images/ingredient/';
const MEALDB_BASE = DO_SPACES_INGREDIENT_BASE;

// Canonical mapping for primary ingredients to verified TheMealDB PNGs
const INGREDIENT_CANONICAL = {
  rice: 'Rice.png',
  idli_rice: 'Rice.png',
  raw_rice: 'Rice.png',
  basmati_rice: 'Basmati%20Rice.png',
  red_rice: 'Rice.png',
  brown_rice: 'Brown%20Rice.png',
  
  toor_dal: 'Lentils.png',
  urad_dal: 'Lentils.png',
  moong_dal: 'Lentils.png',
  chana_dal: 'Lentils.png',
  dal: 'Lentils.png',
  lentils: 'Lentils.png',
  chickpeas: 'Chickpeas.png',
  chana: 'Chickpeas.png',
  rajma: 'Kidney%20Beans.png',
  
  onion: 'Onion.png',
  shallots: 'Shallots.png',
  tomato: 'Tomato.png',
  tomatoes: 'Tomato.png',
  potato: 'Potato.png',
  potatoes: 'Potato.png',
  garlic: 'Garlic.png',
  ginger: 'Ginger.png',
  green_chilli: 'Green%20Chilli.png',
  red_chilli: 'Red%20Chilli.png',
  chilli: 'Red%20Chilli.png',
  carrot: 'Carrots.png',
  beans: 'Green%20Beans.png',
  peas: 'Peas.png',
  cauliflower: 'Cauliflower.png',
  gobi: 'Cauliflower.png',
  cabbage: 'Cabbage.png',
  capsicum: 'Green%20Pepper.png',
  bell_pepper: 'Green%20Pepper.png',
  eggplant: 'Aubergine.png',
  brinjal: 'Aubergine.png',
  spinach: 'Spinach.png',
  keerai: 'Spinach.png',
  drumstick: 'Green%20Beans.png',
  
  coriander: 'Coriander.png',
  curry_leaves: 'Bay%20Leaf.png',
  bay_leaf: 'Bay%20Leaf.png',
  mint: 'Mint.png',
  pudina: 'Mint.png',
  fenugreek: 'Fenugreek.png',
  mustard: 'Mustard.png',
  mustard_seeds: 'Mustard.png',
  cumin: 'Cumin.png',
  cumin_seeds: 'Cumin.png',
  turmeric: 'Turmeric.png',
  black_pepper: 'Black%20Pepper.png',
  pepper: 'Black%20Pepper.png',
  cardamom: 'Cardamom.png',
  cinnamon: 'Cinnamon.png',
  cloves: 'Cloves.png',
  sambar_powder: 'Curry%20Powder.png',
  garam_masala: 'Garam%20Masala.png',
  chilli_powder: 'Chilli%20Powder.png',
  asafoetida: 'Ginger.png',
  hing: 'Ginger.png',
  tamarind: 'Tamarind%20Paste.png',
  
  coconut: 'Desiccated%20Coconut.png',
  grated_coconut: 'Desiccated%20Coconut.png',
  coconut_milk: 'Coconut%20Milk.png',
  
  milk: 'Milk.png',
  curd: 'Yogurt.png',
  yogurt: 'Yogurt.png',
  ghee: 'Ghee.png',
  butter: 'Butter.png',
  paneer: 'Paneer.png',
  cheese: 'Cheese.png',
  cream: 'Heavy%20Cream.png',
  
  chicken: 'Chicken.png',
  egg: 'Egg.png',
  eggs: 'Egg.png',
  fish: 'Fish.png',
  prawns: 'Prawns.png',
  mutton: 'Lamb.png',
  
  wheat: 'Flour.png',
  wheat_flour: 'Flour.png',
  flour: 'Flour.png',
  atta: 'Flour.png',
  maida: 'Flour.png',
  rava: 'Flour.png',
  sooji: 'Flour.png',
  oats: 'Rolled%20Oats.png',
  millet: 'Rolled%20Oats.png',
  poha: 'Rice.png',
  bread: 'Bread.png',
  pav: 'Bread.png',
  noodles: 'Noodles.png',
  pasta: 'Penne%20Rigati.png',
  
  cashews: 'Cashew%20Nuts.png',
  peanuts: 'Peanuts.png',
  roasted_gram: 'Chickpeas.png',
  oil: 'Vegetable%20Oil.png',
  sesame_oil: 'Sesame%20Seed%20Oil.png',
  salt: 'Salt.png',
  rock_salt: 'Salt.png',
  water: 'Water.png',
  lemon: 'Lemon.png',
  lime: 'Lime.png',
  sugar: 'Sugar.png',
  jaggery: 'Brown%20Sugar.png',
  tea: 'Tea.png',
  // Additional pantry ingredients
  soy_sauce: 'Soy%20Sauce.png',
  vinegar: 'Vinegar.png',
  tofu: 'Tofu.png',
  sweetcorn: 'Sweetcorn.png',
  corn: 'Sweetcorn.png',
  spring_onion: 'Spring%20Onions.png',
  scallions: 'Spring%20Onions.png',
  avocado: 'Avocado.png',
  basil: 'Basil.png',
  oregano: 'Basil.png',
  parsley: 'Parsley.png',
  taco: 'Bread.png',
  tortilla: 'Bread.png',
  appalam: 'Flour.png',
  papad: 'Flour.png',
  batter: 'Flour.png',
  yeast: 'Yeast.png',
  sprouts: 'Chickpeas.png',
  salsa: 'Tomato.png',
  hummus: 'Chickpeas.png',
  pickle: 'Lime.png',
  fennel: 'Cumin.png',
  fennel_seeds: 'Cumin.png',
  sesame: 'Sesame%20Seed%20Oil.png',
  poppy_seeds: 'Sesame%20Seed%20Oil.png',
  kasuri_methi: 'Fenugreek.png',
  fenugreek_leaves: 'Fenugreek.png'
};

// Localized Tamil & Hindi keywords to English canonical key
const LOCAL_MAP = {
  // Tamil
  'அரிசி': 'rice',
  'பச்சரிசி': 'rice',
  'புழுங்கல் அரிசி': 'rice',
  'சாதம்': 'rice',
  'சோறு': 'rice',
  'சீரக சம்பா': 'rice',
  'குதிரைவாலி': 'millet',
  'தோசை மாவு': 'batter',
  'தோசை': 'batter',
  'இட்லி மாவு': 'batter',
  'இட்லி': 'rice',
  'பூரி': 'flour',
  'கடலை மாவு': 'flour',
  'கோதுமை மாவு': 'wheat_flour',
  'கோதுமை': 'wheat_flour',
  'ரவை': 'rava',
  'ஓட்ஸ்': 'oats',
  'அவல்': 'poha',
  'துவரம் பருப்பு': 'toor_dal',
  'உளுத்தம் பருப்பு': 'urad_dal',
  'உளுந்து': 'urad_dal',
  'பாசிப்பருப்பு': 'moong_dal',
  'பாசிப்பயறு': 'moong_dal',
  'பச்சை பயறு': 'moong_dal',
  'கொண்டைக்கடலை': 'chickpeas',
  'தக்காளி': 'tomato',
  'வெங்காயம்': 'onion',
  'சின்ன வெங்காயம்': 'shallots',
  'உருளைக்கிழங்கு': 'potato',
  'பூண்டு': 'garlic',
  'இஞ்சி': 'ginger',
  'பச்சை மிளகாய்': 'green_chilli',
  'காய்ந்த மிளகாய்': 'red_chilli',
  'மிளகாய்': 'chilli',
  'கடுகு': 'mustard',
  'சீரகம்': 'cumin',
  'சோம்பு': 'fennel_seeds',
  'பட்டை': 'cinnamon',
  'கிராம்பு': 'cloves',
  'ஏலக்காய்': 'cardamom',
  'கசகசா': 'poppy_seeds',
  'மஞ்சள்': 'turmeric',
  'மஞ்சள் தூள்': 'turmeric',
  'மிளகு': 'black_pepper',
  'பெருங்காயம்': 'hing',
  'வெந்தயம்': 'fenugreek',
  'கறிவேப்பிலை': 'curry_leaves',
  'கொத்தமல்லி': 'coriander',
  'புதினா': 'mint',
  'புளி': 'tamarind',
  'வெல்லம்': 'jaggery',
  'தேங்காய்': 'coconut',
  'தேங்காய்ப்பால்': 'coconut_milk',
  'நெய்': 'ghee',
  'வெண்ணெய்': 'butter',
  'தயிர்': 'curd',
  'பால்': 'milk',
  'பன்னீர்': 'paneer',
  'சிக்கன்': 'chicken',
  'கோழி இறைச்சி': 'chicken',
  'மீன்': 'fish',
  'முட்டை': 'egg',
  'எண்ணெய்': 'oil',
  'நல்லெண்ணெய்': 'sesame_oil',
  'உப்பு': 'salt',
  'தண்ணீர்': 'water',
  'எலுமிச்சை': 'lemon',
  'முந்திரி': 'cashews',
  'முந்திரி விழுது': 'cashews',
  'வேர்க்கடலை': 'peanuts',
  'பொட்டுக்கடலை': 'roasted_gram',
  'சாம்பார் பொடி': 'sambar_powder',
  'கீரை': 'keerai',
  'கேரட்': 'carrot',
  'பீன்ஸ்': 'beans',
  'முருங்கைக்காய்': 'drumstick',
  'கத்திரிக்காய்': 'brinjal',
  'அப்பளம்': 'appalam',
  'கஸ்தூரி மேத்தி': 'kasuri_methi',
  'சோயா சாஸ்': 'soy_sauce',
  'வினிகர்': 'vinegar',
  'டோஃபு': 'tofu',
  'மக்காச்சோளம்': 'sweetcorn',
  'வெங்காயத்தாள்': 'spring_onion',
  'ஊறுகாய்': 'pickle',
  'அவகேடோ': 'avocado',
  'கலவை காய்கறிகள்': 'carrot',
  'ஈஸ்ட்': 'yeast',
  'துளசி': 'basil',
  'பச்சைப் பயறு': 'moong_dal',
  'ஓரிகானோ': 'basil',
  'காய்கறி வடிசாறு': 'carrot',
  'தஹினி': 'sesame',
  'டகோ': 'taco',
  'ரொட்டி': 'bread',
  'சப்பாத்தி': 'bread',
  'குடைமிளகாய்': 'capsicum',
  'பச்சை பட்டாணி': 'peas',
  'பட்டாணி': 'peas',
  'வெள்ளரிக்காய்': 'capsicum',
  'முள்ளங்கி': 'carrot',
  'வாழைக்காய்': 'potato',

  // Hindi
  'चावल': 'rice',
  'अरहर दाल': 'toor_dal',
  'उड़द दाल': 'urad_dal',
  'मूंग दाल': 'moong_dal',
  'चना': 'chickpeas',
  'टमाटर': 'tomato',
  'प्याज': 'onion',
  'आलू': 'potato',
  'लहसुन': 'garlic',
  'अदरक': 'ginger',
  'हरी मिर्च': 'green_chilli',
  'लाल मिर्च': 'red_chilli',
  'राई': 'mustard',
  'जीरा': 'cumin',
  'हल्दी': 'turmeric',
  'काली मिर्च': 'black_pepper',
  'हींग': 'hing',
  'मेथी': 'fenugreek',
  'कढ़ी पत्ता': 'curry_leaves',
  'धनिया': 'coriander',
  'इमली': 'tamarind',
  'नारियल': 'coconut',
  'घी': 'ghee',
  'मक्खन': 'butter',
  'दही': 'curd',
  'दूध': 'milk',
  'पनीर': 'paneer',
  'चिकन': 'chicken',
  'मछली': 'fish',
  'अंडा': 'egg',
  'गेहूं का आटा': 'wheat_flour',
  'आटा': 'flour',
  'सूजी': 'rava',
  'रवा': 'rava',
  'ओट्स': 'oats',
  'तेल': 'oil',
  'नमक': 'salt',
  'पानी': 'water',
  'नींबू': 'lemon',
  'काजू': 'cashews',
  'मूंगफली': 'peanuts',
  'सांभर मसाला': 'sambar_powder',
  'पालक': 'spinach',
  'गाजर': 'carrot',
  'सहजन': 'drumstick',
  'बैंगन': 'brinjal',

  // Telugu
  'బియ్యం': 'rice',
  'కందిపప్పు': 'toor_dal',
  'మినప్పప్పు': 'urad_dal',
  'పెసరపప్పు': 'moong_dal',
  'శనగపప్పు': 'chana_dal',
  'పప్పు': 'lentils',
  'ఉల్లిపాయ': 'onion',
  'టమోటా': 'tomato',
  'బంగాళాదుంప': 'potato',
  'వెల్లుల్లి': 'garlic',
  'అల్లం': 'ginger',
  'పచ్చిమిర్చి': 'green_chilli',
  'ఎండుమిర్చి': 'red_chilli',
  'కొబ్బరి': 'coconut',
  'కొత్తిమీర': 'coriander',
  'కరివేపాకు': 'curry_leaves',
  'ఆవాలు': 'mustard',
  'జీలకర్ర': 'cumin',
  'పసుపు': 'turmeric',
  'మిరియాలు': 'black_pepper',
  'నెయ్యి': 'ghee',
  'వెన్న': 'butter',
  'నూనె': 'oil',
  'ఉప్పు': 'salt',
  'చికెన్': 'chicken',
  'చేప': 'fish',
  'గుడ్డు': 'egg',
  'పెరుగు': 'curd',
  'పాలు': 'milk',
  'పన్నీర్': 'paneer',
  'రవ్వ': 'rava',
  'గోధుమ పిండి': 'wheat_flour',
  'నిమ్మరసం': 'lemon',
  'నిమ్మకాయ': 'lemon',
  'చింతపండు': 'tamarind',
  'జీడిపప్పు': 'cashews',
  'పుదీనా': 'mint',

  // Arabic
  'أرز': 'rice',
  'عدس': 'lentils',
  'حمص': 'chickpeas',
  'بصل': 'onion',
  'طماطم': 'tomato',
  'بطاطس': 'potato',
  'ثوم': 'garlic',
  'زنجبيل': 'ginger',
  'فلفل أخضر': 'green_chilli',
  'فلفل حار': 'chilli',
  'فلفل أسود': 'black_pepper',
  'جوز الهند': 'coconut',
  'كزبرة': 'coriander',
  'أوراق الكاري': 'curry_leaves',
  'أوراق كاري': 'curry_leaves',
  'خردل': 'mustard',
  'كمون': 'cumin',
  'كركم': 'turmeric',
  'سمن': 'ghee',
  'زبدة': 'butter',
  'زيت': 'oil',
  'ملح': 'salt',
  'دجاج': 'chicken',
  'سمك': 'fish',
  'بيض': 'egg',
  'لبن': 'curd',
  'زبادي': 'curd',
  'حليب': 'milk',
  'بانير': 'paneer',
  'جبن': 'cheese',
  'دقيق': 'flour',
  'سميد': 'rava',
  'ليمون': 'lemon',
  'تمر هندي': 'tamarind',
  'كاجو': 'cashews',
  'نعناع': 'mint'
};

export function getIngredientImageUrl(rawName) {
  if (!rawName) return `${MEALDB_BASE}Salt.png`;
  const clean = rawName.trim().toLowerCase();

  // 1. Direct check in localized map
  for (const [locKey, enKey] of Object.entries(LOCAL_MAP)) {
    if (clean.includes(locKey.toLowerCase())) {
      const file = INGREDIENT_CANONICAL[enKey];
      if (file) return `${MEALDB_BASE}${file}`;
    }
  }

  // 2. English keyword matches
  for (const [key, file] of Object.entries(INGREDIENT_CANONICAL)) {
    const formattedKey = key.replace(/_/g, ' ');
    if (clean.includes(formattedKey)) {
      return `${MEALDB_BASE}${file}`;
    }
  }

  // 3. Fallback based on common generic keywords
  if (clean.includes('rice') || clean.includes('sadam') || clean.includes('chawal')) return `${MEALDB_BASE}Rice.png`;
  if (clean.includes('dal') || clean.includes('paruppu') || clean.includes('gram')) return `${MEALDB_BASE}Lentils.png`;
  if (clean.includes('oil') || clean.includes('ennai') || clean.includes('tel')) return `${MEALDB_BASE}Vegetable%20Oil.png`;
  if (clean.includes('chilli') || clean.includes('pepper') || clean.includes('powder')) return `${MEALDB_BASE}Chilli%20Powder.png`;
  if (clean.includes('flour') || clean.includes('batter') || clean.includes('dough')) return `${MEALDB_BASE}Flour.png`;
  if (clean.includes('herb') || clean.includes('leaf') || clean.includes('leaves')) return `${MEALDB_BASE}Bay%20Leaf.png`;
  if (clean.includes('masala') || clean.includes('spice')) return `${MEALDB_BASE}Garam%20Masala.png`;

  // Default clean culinary salt/seasoning
  return `${MEALDB_BASE}Salt.png`;
}
